<!--测评-->
<template>
    <div class="TestPaper">
        <detail-title></detail-title>
        <div v-if="result.length == 0" style="padding:5rem 0 1rem 0;">
            <img src="@/assets/image/bg-ceping.jpg" style="width:100%;">
            <div style="padding:1rem 2rem;">
                <el-form>
                    <el-form-item v-for="(item,index) in options" :key="index">
                        <div>
                            <div class="Paper-name">
                                {{index+1}}、{{item.title}}
                            </div>
                            <div v-for="t in item.option">
                                <el-radio-group v-model="item.modelValue">
                                    <el-radio :label="t.num" border>{{t.name+'、'+t.content}}</el-radio>
                                </el-radio-group>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
                <button  type="button" class="ceping-button" @click="saveAnswer()">提交测评</button>
            </div>
        </div>
        <div v-if="result.length>0" style="padding:10rem 1rem 5rem 1rem;text-align:center;">
            <p style="width:100%;"><img src="@/assets/image/bg-result.jpg" style="height:35vh;"></p>
            <div style="margin-top: -15vh;">
                <p style="font-size: 1.2rem;color: #333333;">{{result[0]}}</p>
                <p style="font-size: 1.6rem;line-height: 2;color: #d7434c;"><strong>{{result[1]}}</strong></p>
            </div>
            <div class="paper-footer">
                <span>
                    <a :href="'tel:' + tell"><img src="@/assets/image/white-tell.svg">{{tell}}</a>
                </span>
                <p class="paper-fot">可拨打服务电话，获取您的专属税收筹划方案！</p>
            </div>
        </div>
        <share-wechat></share-wechat>
    </div>
</template>
<script>
import DetailTitle from "@/components/DetailTitle";
import { eventBus } from '@/assets/js/eventBus';
import ShareWechat from "@/components/ShareWechat";
import Axios from 'axios';
export default {
    data(){
        return{
            options:[],
            total:0,
            tpmResult:[],
            result:[],
            tell: "400-829-6689",
        };
    },
    mounted(){
        const that = this;
        var locations = location.href;
        that.getList();
        var shareList={
            title: "风险测评",
            content: "您的企业存在风险吗？快来测一测",
        }
        eventBus.$emit("shareList",shareList);
    },
    methods:{
        //获取数据
        getList(){
            const that = this;
            Axios.get(that.$store.state.APIURLS + "Tpm/findById").then(function(res) {
                if(res.data.code == 200){
                    var lists = $.parseJSON(res.data.data.tpmContent);
                    lists.forEach((el) => {
                        el.modelValue ='';
                    })
                    that.options =lists;
                    var m = $.parseJSON(res.data.data.tpmResult);
                    m.forEach((e) => {
                        e.content = e.content.split("/")
                    })
                    that.tpmResult = m;
                }
            })
        },
        //提交测评结果
        saveAnswer(){
            const that = this;
            for(var i=0;i<that.options.length;i++){
                if(that.options[i].modelValue || that.options[i].modelValue != 0){
                    that.total = that.total+parseInt(that.options[i].modelValue);
                }
            }
            if(that.total != 0){
                that.tpmResult.forEach((e) => {
                    if(e.min < that.total && e.max >= that.total){
                        that.result=e.content;
                    }
                });
            }else{
                that.$toast({ message: '至少选择一道题',type: "success", position: "middle",duration: "2000"});
            }
        },
    },
    components: {
        DetailTitle,
        ShareWechat
    },
};
</script>